let applyingCommandId: string | undefined;
let applyingCommandAt: number | undefined;
export function currentActivityCommandTime() {
  return applyingCommandAt;
}
export function currentActivityCommandId() {
  return applyingCommandId;
}
/** The command router serializes invocations; the session journal includes this
 * ID in the same durable write as the resulting local state change. */
export async function withActivityCommand<T>(
  id: string | undefined,
  run: () => T | Promise<T>,
  at?: number,
) {
  applyingCommandId = id;
  applyingCommandAt = at;
  try {
    return await run();
  } finally {
    applyingCommandId = undefined;
    applyingCommandAt = undefined;
  }
}
